<h1>Actor Form Details....</h1>
<div class="form-group text-center">
  <CustomDataByRequestType RequestedType="FDTemplateByActorReportCode" ActorCode='{{ActorCode}}' id="ActorReportCode" [(ngModel)]="ActorReportCode" *ngIf="ActorCode > 0"
                           name="ActorReportTemplateCode" required>
  </CustomDataByRequestType>
  <!--(keyChange)="onSubmitActorReport($event)"-->
</div>
<div class="form-group text-center">
  <button type="button" class="btn btn-warning btn-raised" (click)="onSubmitActorReport()" *ngIf='!isRequesting'>Open</button>
  </div>
<div *ngIf="CurrentFdActorDocReportDetailsController">
  <div *ngFor="let c of CurrentFdActorDocReportDetailsController; let i = index" [ngSwitch]="c.ValueType">
    <div class="row">

      <div class="form-group col-12 mb-2">

        <!--<label for="eventInput2" *ngIf="c.CanShowTitle">{{c.AttributeName}}</label>-->

        <label for="eventInput2" >{{c.AttributeName}}</label>
        <div class="form-group" *ngSwitchCase="'Text'">
          <input type="text" class="form-control" id="c.ValueData"
                 [(ngModel)]="c.ValueData" name="c.ValueData" placeholder="Value">
        </div>
        <div class="form-group" *ngSwitchCase="'CsvList'">
          <div *ngFor="let cc of c.ValueSource | splitpipe:','">
            <div>
              <label for="eventInput2"> {{cc}}</label>
              <input type="radio" class="form-control" value="{{cc}}" name="{{i}}"
                     [(ngModel)]="c.ValueData"
                      placeholder="Value" checked="checked">

            </div>
           

          </div>

          <!--<div *ngFor="let cc of c.ValueSource | splitpipe:','">
            <div *ngIf='cc === c.ValueData; else notradiomatch'>
              <label for="eventInput2"> {{cc}}</label>
              <input type="radio" class="form-control" value="{{cc}}" name="{{i}}" (click)="setradioAnswer($event.target.value,i)" placeholder="Value" checked="checked">

            </div>
            <ng-template #notradiomatch>
              <div>
                <label for="eventInput2"> {{cc}}</label>
                <input type="radio" class="form-control" value="{{cc}}" name="{{i}}" (click)="setradioAnswer($event.target.value,i)" placeholder="Value">

              </div>
            </ng-template>

          </div>-->
          <!--(click)="setradioAnswer({{cc}},i)"-->

        </div>
      </div>
    </div>
  </div>
  <div *ngIf="CurrentFdActorDocReportDetailsController.length >0">
    <button type="submit" class="btn btn-warning btn-raised" (click)="SaveFDActorDocReportDetails()" *ngIf='!isRequesting'>Save</button>
  </div>
</div>
